import { WidgetAnimationRenderer } from "../widget-animation.renderer";
import { ElementStyleService } from "../../../services/element-style.service";
import { IStoreSubscriptionDetailsWidgetStyle } from "src/typings/store-subscription-details-data";

export class StoreSubscriptionDetailsStyleRenderer {

    private readonly animationRenderer: WidgetAnimationRenderer;

    constructor(private readonly styleService: ElementStyleService) {
        this.animationRenderer = new WidgetAnimationRenderer(this.styleService);
    }

    public render(element: HTMLElement, style: IStoreSubscriptionDetailsWidgetStyle): void {
        this.animationRenderer.setAnimationStyles(element, style.animation);
    }

}
